import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  SETUP_ERROR_BOX_STYLES,
  SETUP_ERROR_CODE_BOX_STYLES,
  SETUP_ERROR_CODE_CONTENT_STYLES,
} from '../styles/universal-location-map.styles';

export interface MapSetupErrorProps {
  height: string | number;
  isUniversalMapsEnabled: boolean;
  hasGoogleKey: boolean;
  hasBaiduKey: boolean;
}

export function MapSetupError({
  height,
  isUniversalMapsEnabled,
  hasGoogleKey,
  hasBaiduKey,
}: MapSetupErrorProps) {
  const { t } = useTranslation();
  const setupErrorMessage = !isUniversalMapsEnabled ? t('map.notEnabled') : '';
  const setupErrorKeysMessage =
    !hasGoogleKey && !hasBaiduKey ? t('map.noApiKeys') : '';

  const boxStyles = { ...SETUP_ERROR_BOX_STYLES, height };

  return (
    <Box sx={boxStyles}>
      <Box sx={{ fontSize: '24px', mb: 2 }}>🗺️</Box>
      <Box sx={{ fontWeight: 'bold', mb: 1 }}>{t('map.configRequired')}</Box>
      <Box sx={{ fontSize: '14px', color: 'text.secondary', mb: 2 }}>
        {setupErrorMessage}
        {setupErrorKeysMessage}
      </Box>
      <Box sx={SETUP_ERROR_CODE_BOX_STYLES}>
        <div>{t('map.addToEnvLocal')}</div>
        <div style={SETUP_ERROR_CODE_CONTENT_STYLES}>
          NEXT_PUBLIC_ENABLE_UNIVERSAL_MAPS=true
          <br />
          NEXT_PUBLIC_DEFAULT_MAP_PROVIDER=google
          <br />
          NEXT_PUBLIC_GOOGLE_MAPS_API_KEY=your_api_key_here
        </div>
      </Box>
    </Box>
  );
}
